import { ResponseMapper } from '../../utils/httpclient/response/responsemapper';
import { GetPlaylistRequest } from '../api/banner/getplaylist/getplaylistrequest';
import { GetPlaylistResponse, GetPlaylistResponseDtoImpl } from '../api/banner/getplaylist/getplaylistresponse';
import { GetPlaylistBuilder } from '../dto/getplaylist/getplaylistbuilder';
import { APIFeatures } from '../util/apifeatures';
import { StatusCodes } from '../util/statuscodes';
import { SixdeeCRBTAPIProcessor } from './sixdeecrbtapiprocessor';
import { Strings } from '../../utils/resources/strings';

export class GetPlaylistAPIProcessorImpl extends SixdeeCRBTAPIProcessor<GetPlaylistRequest, GetPlaylistResponse>
{
    execute(request: GetPlaylistRequest): void 
    {
        super.execute(request);
    }

    onSuccess(responseMapper: ResponseMapper): void 
    {
        super.onSuccess(responseMapper);
        try {

            if (+responseMapper.getStatusCode() === StatusCodes.SUCCESS) {

                let response = new GetPlaylistResponseDtoImpl(APIFeatures.GET_PLAY_LIST, "Get Playlist Success");

                response.setPlaylistDto(new GetPlaylistBuilder(responseMapper.getResponseMap()).buildAll());

                this.getAPISuccess(response);
            }
            else if(+responseMapper.getStatusCode() === StatusCodes.NO_CONTENT)
            {
                this.getAPISuccess(new GetPlaylistResponseDtoImpl(APIFeatures.GET_PLAY_LIST, this.getContext().getResources().getString(Strings.no_data_list_available)));
            }
            else if(+responseMapper.getStatusCode() === StatusCodes.INTERNAL_SERVER_ERROR)
            {
                this.getAPIFailure(new GetPlaylistResponseDtoImpl(APIFeatures.GET_PLAY_LIST, this.getContext().getResources().getString(Strings.internal_server_error)));
            }
        }
        catch (e) {
            this.getAPIFailure(new GetPlaylistResponseDtoImpl(APIFeatures.GET_PLAY_LIST, this.getContext().getResources().getString(Strings.internal_server_error)));
        }
    }

    onFailure(responseMapper: ResponseMapper): void 
    {
        super.onFailure(responseMapper);

            this.getAPIFailure(new GetPlaylistResponseDtoImpl(APIFeatures.GET_PLAY_LIST, responseMapper.getStatusMsg()));
        
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processor/getplaylistapiprocessor.tsx